import { render, staticRenderFns } from "./SpkbPiutang.vue?vue&type=template&id=2cf23a44&"
import script from "./SpkbPiutang.vue?vue&type=script&lang=js&"
export * from "./SpkbPiutang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports